export default {
  title: 'Menus de Acesso',
  description: 'Defina quais itens aparecem nos menus de acesso, seus nomes, endereços e ordem de exibição.',
  labels: {
    new: 'Novo item',
    source: 'Disponíveis',
  },
  form: {
    title: 'Cadastro de Item',
  },
  groups: {
    routeData: 'Dados do Item',
    names: 'Nomes do Item',
    alias: 'Aliases do Item'
  },
  fields: {
    url: 'URL',
    parent: 'Parent',
    is_logged: 'Página logada',
    is_displayed: 'Exibido no Menu',
    is_active: 'Ativo',
    slug: 'Slug',
    options: 'Opções',
    display_order: 'Ordem de Exibição',
    language: 'Idioma',
    name: 'Nome',
  },
  names: {
    title: 'Nomes de Item',
    labels: { new: 'Novo Nome' },
    fields: { name: 'Nome do Item' }
  },
  alias: {
    title: 'URL alternativa',
    labels: { new: 'Novo Slug' },
    fields: { alias: 'Slug do Item' }
  }
};
